import React, { useState } from 'react';
import api from '../services/api';
import './Login.css';

// ─── Autorisation du connecteur Claude (2026-10-22) ──────────────────────────
// Claude envoie ici la personne (via /api/oauth/authorize) pour qu'elle
// autorise l'accès. Elle est déjà connectée (Microsoft + double
// authentification) ; on lui dit exactement ce que Claude pourra lire.
export default function Connecteur({ demande, onFin }) {
  const [envoi, setEnvoi] = useState(false);
  const [erreur, setErreur] = useState('');
  const decider = async (accord) => {
    setEnvoi(true); setErreur('');
    try {
      const r = await api.post('/oauth/decision', { demande, accord });
      onFin();
      window.location.href = r.data.redirection;
    } catch (e) {
      setErreur(e.response?.data?.error || 'Autorisation impossible');
      setEnvoi(false);
    }
  };
  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-brand">
          <h1 className="login-mark" aria-label="A97 BI">A<span>97</span><span className="login-mark-app">BI</span></h1>
          <span className="login-subtitle">Connecter Claude à A97 BI</span>
        </div>
        {erreur && <div className="login-error" role="alert"><span>{erreur}</span></div>}
        <p className="da-texte">Claude pourra lire, à votre demande, le <b>résumé de la veille</b> des concessions de vos accès :
          ventes VN et VO, après-vente, pièces, trésorerie et créances clients.</p>
        <p className="da-texte">Les concessions lui sont transmises sous leur nom ; aucun nom de personne (vendeur, compagnon, client).
          Lecture seule ; chaque demande est tracée.</p>
        <div className="da-form">
          <button type="button" className="login-ms-button" disabled={envoi} onClick={() => decider(true)}>
            {envoi ? <><span className="spinner" /> Autorisation…</> : 'Autoriser Claude'}
          </button>
        </div>
        <p className="login-legal"><button type="button" className="da-lien" disabled={envoi} onClick={() => decider(false)}>Refuser</button></p>
      </div>
      <div className="login-bg-overlay" />
    </div>
  );
}
